module.exports = __webpack_public_path__ + "static/media/proposal_verification_audio.969482a4.mp3";